import { useGameStore } from '../../store/gameStore';
import { REVERSE_CARDS } from '../../data';
import { useAutoConfirm } from '../../hooks/useAutoConfirm';
import type { ReverseCard } from '../../types';
import styles from './ReverseShop.module.css';

interface Props {
  onClose: () => void;
}

export default function ReverseShop({ onClose }: Props) {
  const { currentPlayerIndex, players, addReverseCard, deductMoney, addLog } = useGameStore();
  const currentPlayer = players[currentPlayerIndex];

  const { countdown, cancelAutoConfirm } = useAutoConfirm({
    onAutoConfirm: onClose,
    delayMs: 15000,
    enabled: true,
  });

  if (!currentPlayer) return null;

  const handleBuy = (card: ReverseCard) => {
    const cost = card.cost ?? 9999;
    if (currentPlayer.money < cost) return;
    if (currentPlayer.reverseCards.length >= 3) return;
    deductMoney(currentPlayer.id, cost);
    addReverseCard(currentPlayer.id, card.id as any);
    addLog(currentPlayer.id, `在反转商店购买了 ${card.emoji}${card.name}，花费 ¥${cost}`, 'card');
    onClose();
  };

  const canAffordAny = REVERSE_CARDS.some(c => (c.cost ?? 9999) <= currentPlayer.money);
  const handFull = currentPlayer.reverseCards.length >= 3;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <span className={styles.title}>🔄 反转商店</span>
          <button className={styles.closeBtn} onClick={onClose}>✕</button>
        </div>
        <div className={styles.subtitle}>
          {currentPlayer.name} 的余额：<span className={styles.gold}>{currentPlayer.money.toLocaleString()}</span>
        </div>
        <div className={styles.cardList}>
          {REVERSE_CARDS.map(card => {
            const cost = card.cost ?? 9999;
            const affordable = currentPlayer.money >= cost;
            return (
              <div key={card.id} className={`${styles.card} ${!affordable ? styles.cardDisabled : ''}`}>
                <div className={styles.cardHeader}>
                  <span className={styles.cardEmoji}>{card.emoji}</span>
                  <span className={styles.cardName}>{card.name}</span>
                  <span className={styles.cardCost}>¥{cost}</span>
                </div>
                <div className={styles.cardDesc}>{card.description}</div>
                <button
                  className={styles.buyBtn}
                  disabled={!affordable || handFull}
                  onClick={() => handleBuy(card)}
                >
                  {!affordable ? '余额不足' : handFull ? '手牌已满' : '购买'}
                </button>
              </div>
            );
          })}
        </div>
        {!canAffordAny && (
          <div className={styles.warning}>余额不足以购买任何反转卡</div>
        )}
        {handFull && (
          <div className={styles.warning}>手牌已满3张，无法购买更多！</div>
        )}
        <div className={styles.countdown}>⏰ {countdown}s 后自动关闭</div>
        <button className={styles.skipBtn} onClick={() => { cancelAutoConfirm(); onClose(); }}>
          不购买，跳过
        </button>
      </div>
    </div>
  );
}
